import React from 'react'

import { SIconSpan } from '../../../common/styles/Icons'

interface IHaloIconProps {
    fill?: string
    size?: number
    title?: string
    id?: string
}

const HaloIcon = ({ fill = '#535353', title, id = 'info-icon', size = 147 }: IHaloIconProps): React.ReactElement => {
    return (
        <SIconSpan title={title} id={id} size={size} className="align-items-center justify-content-center">
            <svg width="100%" height="100%" viewBox="0 0 147 115" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M73.4999 34.7876C83.9722 34.7876 93.1217 38.8413 95.5594 50.891C97.997 62.9406 94.0968 72.2222 89.4684 75.8496C84.8368 79.4769 78.3103 80.7691 73.4999 80.7691C68.6928 80.7691 62.1631 79.4769 57.5315 75.8496C52.8999 72.2222 49.0028 62.9406 51.4405 50.891C53.8782 38.8413 63.0276 34.7876 73.4999 34.7876V34.7876Z"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M73.4999 114.258C88.7078 114.258 107.806 113.346 123.976 103.511C140.146 93.6748 150.277 70.6512 143.91 41.4749C137.533 12.2658 113.286 1.16399 73.4999 1.16399C33.7137 1.16399 9.46685 12.2658 3.08986 41.4749C-3.28062 70.6512 6.8504 93.6748 23.0236 103.511C39.1968 113.346 58.2953 114.258 73.4999 114.258Z"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M73.5 113.11C88.3992 113.11 107.111 112.215 122.953 102.579C138.794 92.9434 148.721 70.3888 142.48 41.8062C136.233 13.1874 112.477 2.31189 73.5 2.31189C34.5231 2.31189 10.767 13.1874 4.52004 41.8029C-1.72043 70.3856 8.20582 92.9401 24.0475 102.576C39.8892 112.212 58.6009 113.107 73.5 113.107V113.11Z"
                    stroke={fill}
                    strokeMiterlimit="10"
                />
                <path
                    d="M86.956 66.3679H84.9376L80.6278 58.8672C80.4425 58.5458 80.1305 58.3621 79.7892 58.3621H79.7665C79.422 58.372 79.1002 58.5786 78.9279 58.9131L75.9149 64.8363C75.4404 65.7677 74.5173 66.345 73.5 66.345C72.4827 66.345 71.5596 65.771 71.0851 64.8363L68.0688 58.9099C67.9031 58.5819 67.5813 58.3654 67.2368 58.3589C66.8955 58.3457 66.564 58.5392 66.3755 58.8705L62.0624 66.3712H60.0375L64.8608 57.985C65.3711 57.1027 66.304 56.5681 67.279 56.6009C68.2639 56.6239 69.1609 57.2044 69.6192 58.1096L72.6354 64.0295C72.8434 64.4394 73.214 64.5805 73.4968 64.5805C73.7795 64.5805 74.15 64.4362 74.3581 64.0295L77.371 58.1096C77.8358 57.2044 78.7329 56.6239 79.7177 56.6009C80.7026 56.5747 81.6256 57.106 82.1359 57.9882L86.9495 66.3679H86.956Z"
                    fill={fill}
                />
                <path
                    d="M80.3971 54.9381H78.3787L74.3354 47.9064C74.0883 47.4702 73.6691 47.4177 73.5033 47.4177C73.3375 47.4177 72.9183 47.4702 72.6647 47.9064L68.6279 54.9381H66.603L71.1501 47.0209C71.6409 46.1682 72.5217 45.6565 73.5 45.6565C74.4784 45.6565 75.3527 46.1682 75.8467 47.0209L80.3938 54.9381H80.3971Z"
                    fill={fill}
                />
            </svg>
        </SIconSpan>
    )
}

export default HaloIcon
